import { create } from "zustand";

export const useFaviconStore = create((set) => ({
  favicon: null,
  setFavicon: (url) => set({ favicon: url }),
}));
